<template>
  <div>
    <v-navigation-drawer
      v-model="isOpen"
      :width="$isMobile ? '100%' : '50%'"
      right
      fixed
      :permanent="isOpen"
      hide-overlay
      class="z-index--100">
      <div class="ma-3">
        <div class="mb-5">
          <div class="d-flex">
            <v-btn
              dark
              fab
              x-small
              outlined
              color="primary"
              class="mr-3"
              @click="close"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <div class="subtitle-1 primary--text">
              Descrgar facturas y crear órdenes de compra
            </div>
          </div>
        </div>
        <div class="my-4">
          <v-menu
            ref="datePicker"
            v-model="datePicker"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="range"
                label="Rango de fechas"
                prepend-icon="mdi-calendar"
                readonly
                hide-details
                dense
                outlined
                rounded
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dates"
              :range="true"
              first-day-of-week="1"
              no-title
              :max="untilNow"
              locale="es-mx"
            >
              <div class="d-flex">
                <v-spacer />
                <v-btn text color="grey" @click="resetDates">Cancel</v-btn>
                <v-btn :disabled="dates.length < 2" color="primary" @click="load(null)">OK</v-btn>
              </div>
            </v-date-picker>
          </v-menu>
        </div>
        <div>
          <div class="mb-4">
            <v-card>
              <v-data-table
                :items="table.items"
                :headers="headers"
                :server-items-length="table.total"
                :loading-text="table.title"
                :loading="table.loading"
                :items-per-page="table.options.itemsPerPage"
                :page="table.options.page"
                :footer-props="{
                  'items-per-page-options': [20, 50, 100]
                }"
                @update:options="updateTable">
                <template v-slot:item.uuid="{ item }">
                  <v-progress-circular
                    v-if="loadingBtn && loadingBtn === item.id"
                    indeterminate
                    color="primary"
                  />
                  <a v-else href="#" @click.prevent="openDetail(item)">{{ item.uuid }} | {{ item.id }}</a>
                </template>
                <template v-slot:item.issuedAt="{ item }">
                  {{ item.issuedAt | toDate }}
                </template>
                <template v-slot:item.total="{ item }">
                  {{ item.total | toFixNumber | numberWithComma | prefix('$') }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-tooltip v-if="item.selectable" left>
                    <template
                      v-slot:activator="{ on }">
                      <v-btn
                        fab
                        x-small
                        depressed
                        color="success"
                        v-on="on"
                        :disabled="disabled"
                        :loading="item.id === loadingBtn"
                        @click="openConfirmDialog(item)">
                        <v-icon small>mdi-cloud-upload</v-icon>
                      </v-btn>
                    </template>
                    <span>Crear orden de compra</span>
                  </v-tooltip>
                  <div v-else class="primary--text">
                    Ya existe una orden de compra para esta factura
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </div>
        </div>
      </div>
    </v-navigation-drawer>

    <v-dialog
      @keydown.esc="confirmDialog=false"
      persistent
      v-model="confirmDialog"
      max-width="500"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Confirmar</span>
        </v-card-title>
        <v-card-text>
          <div class="mb-3">
            ¿Deseas crear la orden de compra para esta factura?
          </div>
          <v-card outlined class="mb-3 px-3">
            <v-row>
              <v-col cols="12" sm="6">
                UUID:
                <b>{{ selectedItem.uuid }}</b>
              </v-col>
            </v-row>
          </v-card>
          <v-card outlined class="mb-3 px-3">
            <v-row>
              <v-col cols="12" sm="6">
                Proveedor:
                <b>
                  {{ selectedItem.issuer }}
                </b>
              </v-col>
            </v-row>
          </v-card>
          <v-card outlined class="mb-3 px-3">
            <v-row>
              <v-col cols="12" sm="6">
                Área:
                <b>
                  {{ area.name }}
                </b>
              </v-col>
            </v-row>
          </v-card>
          <v-card outlined class="mb-3">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Producto
                    </th>
                    <th class="text-right">
                      Cantidad
                    </th>
                    <th class="text-left">
                      Unidad
                    </th>
                    <th class="text-left">
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(product, index) in selectedItem.products"
                    :key="`product-${index}`"
                  >
                    <td>
                      {{ product.name }}
                    </td>
                    <td>
                      {{ product.quantity }}
                    </td>
                    <td>
                      <span v-if="product.unit">
                        {{ product.unit.name }}
                      </span>
                      <span v-else class="red--text">
                        Unidad de medida no existe
                      </span>
                    </td>
                    <td>
                      {{ product.total | toFixNumber | numberWithComma | prefix('$') }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="confirmDialog = false">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            rounded
            @click="createOrder()">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <InvoiceViewer ref="invoiceViewer" />

    <v-overlay :value="loading" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import InvoiceViewer from '@/components/modals/InvoiceViewer'
import moment from 'moment'
const { parseStringPromise } = require('xml2js')

export default {
  components: { InvoiceViewer },
  data () {
    return {
      isOpen: false,
      loading: false,
      disabled: false,
      datePicker: false,
      confirmDialog: false,
      selectedItem: {},
      xml: null,
      loadingBtn: '',
      table: {
        loading: false,
        title: 'Descargando facturas',
        total: 0,
        items: [],
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 20,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        }
      },
      dates: []
    }
  },
  computed: {
    headers () {
      return [
        { text: this.$i18n.t('UUID'), value: 'uuid', sortable: true },
        { text: this.$i18n.t('Proveedor'), value: 'issuer.name', sortable: false },
        { text: this.$i18n.t('Fecha de facturación'), value: 'issuedAt', sortable: false },
        { text: this.$i18n.t('Total'), value: 'total', sortable: false },
        { text: this.$i18n.t(''), value: 'actions', sortable: false }
      ]
    },
    taxId () {
      return ((this.$store.state.currentRestaurant.taxInformation || {}).data || {}).taxId
    },
    area () {
      return this.$store.state.area
    },
    areaId () {
      return this.area.id
    },
    units () {
      return this.$store.state.login.units.data
    },
    untilNow () {
      return moment().format('YYYY-MM-DD')
    },
    range () {
      return this.dates.length < 2 ? '' : `${this.dates[0]} / ${this.dates[1]}`
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  methods: {
    keyDownHandler (event) {
      if (event.code === 'Escape') this.isOpen = false
    },
    open () {
      this.isOpen = true
    },
    close () {
      this.isOpen = false
    },
    async updateTable (options) {
      if (this.dates.length) {
        const params = {
          startDate: this.$moment(this.dates[0]).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
          endDate: this.$moment(this.dates[1]).endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
          rfc: this.taxId,
          type: 'I',
          status: 'VIGENTE',
          isIssuer: false,
          limit: options.itemsPerPage,
          page: options.page
        }
        await this.load(params)
      }
    },
    async load (params = null) {
      this.table.loading = true
      try {
        this.dates.sort((a, b) => {
          if (a < b) return -1
          if (a > b) return 1
          return 0
        })
        params = params || {
          startDate: this.$moment(this.dates[0]).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
          endDate: this.$moment(this.dates[1]).endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
          rfc: this.taxId,
          type: 'I',
          status: 'VIGENTE',
          isIssuer: false,
          limit: this.table.options.itemsPerPage,
          page: this.table.options.page
        }
        this.datePicker = false
        const response = await this.$api.get(`/v1/invoices`, params)
        this.table.items = response.items.sort(i => i.selectable ? -1 : 1)
        this.table.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    async getXml (id) {
      let xml = null
      this.disabled = true
      this.loadingBtn = id
      try {
        const { invoice } = await this.$api.get(`/v1/invoices/${id}/cfdi`)
        xml = invoice
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.disabled = false
      this.loadingBtn = ''
      return xml
    },
    async openDetail (item) {
      const invoice = {}
      invoice.xml = item.invoice
      invoice.sourceId = item.id
      await this.$refs.invoiceViewer.open(invoice)
    },
    async openConfirmDialog (item) {
      const xml = await this.getXml(item.id)
      this.xml = xml
      this.selectedItem = await this.parseInvoice(xml)
      this.confirmDialog = true
    },
    async createOrder () {
      this.loading = true
      try {
        const payload = {
          area: this.areaId,
          xml: this.xml
        }
        await this.$api.post(`/v1/orders/create-by-invoice`, payload)
        await this.load()
        this.$toasted.show('La orden de compra se creó correctamente', { duration: 3000, type: 'success' })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.loading = false
      this.confirmDialog = false
    },
    async resetDates () {
      this.dates = []
      this.datePicker = false
    },
    async parseInvoice (xmlString) {
      const content = await parseStringPromise(xmlString)
      const invoice = content['cfdi:Comprobante']
      const issuer = invoice['cfdi:Emisor'][0].$.Nombre
      const receiver = invoice['cfdi:Receptor'][0].$.Nombre
      const items = invoice['cfdi:Conceptos'][0]['cfdi:Concepto']
      const digitalCertificate = invoice['cfdi:Complemento'][0]['tfd:TimbreFiscalDigital'][0]['$']
      const products = items.map(product => {
        const productTaxes = product['cfdi:Impuestos']
          ? product['cfdi:Impuestos'][0]
          : null

        const translations = productTaxes
          ? productTaxes['cfdi:Traslados'][0]['cfdi:Traslado']
          : []

        const retentions = productTaxes
          ? productTaxes['cfdi:Retenciones']
            ? productTaxes['cfdi:Retenciones'][0]['cfdi:Retencion'].map(tax => {
              tax.$.IsRetention = true
              return tax
            })
            : []
          : []

        const taxes = translations.concat(retentions)
        const totalTaxes = taxes.reduce((acc, val) => {
          return acc + (val.$ ? Number(val.$.Importe || 0) : 0)
        }, 0)
        const unitCode = new RegExp(product.$.ClaveUnidad, 'i')
        return {
          clave: product.$.ClaveProdServ,
          name: product.$.Descripcion,
          unit: this.units.find(unit => unitCode.test(unit.satCode)),
          quantity: parseFloat(product.$.Cantidad),
          cost: parseFloat(product.$.ValorUnitario),
          discount: parseFloat(product.$.Descuento) || 0,
          subtotal: parseFloat(product.$.Importe),
          total: (parseFloat(product.$.Importe) - (parseFloat(product.$.Descuento) || 0) + totalTaxes)
        }
      })

      return {
        uuid: digitalCertificate['UUID'],
        issuer,
        receiver,
        total: parseFloat(invoice.$.Total),
        subtotal: parseFloat(invoice.$.SubTotal),
        products
      }
    }
  }
}
</script>
